export default "__VITE_ASSET__NN9MqvW9__"